// ============ Swiper + Pills + Timeline Progress ============
/**
 * Toast Notification Utility
 * Replaces browser alert() with styled inline toast notifications.
 */ let $397db21d7eb861a2$var$activeToast = null;
function $397db21d7eb861a2$export$f6cef6fcf9ca4e17(message, type = "error", duration = 5000) {
    // Remove existing toast if any
    if ($397db21d7eb861a2$var$activeToast) {
        $397db21d7eb861a2$var$activeToast.remove();
        $397db21d7eb861a2$var$activeToast = null;
    }
    const icons = {
        error: `<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><path d="m15 9-6 6"/><path d="m9 9 6 6"/></svg>`,
        success: `<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><path d="m9 12 2 2 4-4"/></svg>`,
        warning: `<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="m21.73 18-8-14a2 2 0 0 0-3.48 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3"/><path d="M12 9v4"/><path d="M12 17h.01"/></svg>`
    };
    const colors = {
        error: {
            bg: "#FEF2F2",
            border: "#FCA5A5",
            text: "#991B1B",
            icon: "#DC2626"
        },
        success: {
            bg: "#F0FDF4",
            border: "#86EFAC",
            text: "#166534",
            icon: "#16A34A"
        },
        warning: {
            bg: "#FFFBEB",
            border: "#FCD34D",
            text: "#92400E",
            icon: "#D97706"
        }
    };
    const c = colors[type] || colors.error;
    const toast = document.createElement("div");
    toast.className = "ql-toast";
    toast.setAttribute("role", "alert");
    toast.innerHTML = `
    <div style="
      position: fixed;
      top: 24px;
      left: 50%;
      transform: translateX(-50%) translateY(-20px);
      z-index: 99999;
      display: flex;
      align-items: center;
      gap: 10px;
      padding: 14px 22px;
      border-radius: 12px;
      background: ${c.bg};
      border: 1px solid ${c.border};
      color: ${c.text};
      font-family: 'Public Sans', system-ui, sans-serif;
      font-size: 14px;
      font-weight: 500;
      box-shadow: 0 8px 30px rgba(0,0,0,0.12);
      opacity: 0;
      transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
      max-width: 90vw;
      line-height: 1.4;
    ">
      <span style="color: ${c.icon}; flex-shrink: 0; display: flex;">${icons[type] || icons.error}</span>
      <span>${message}</span>
      <button onclick="this.closest('.ql-toast').remove()" style="
        background: none;
        border: none;
        color: ${c.text};
        cursor: pointer;
        padding: 0 0 0 8px;
        font-size: 18px;
        line-height: 1;
        opacity: 0.6;
        flex-shrink: 0;
      ">&times;</button>
    </div>
  `;
    document.body.appendChild(toast);
    $397db21d7eb861a2$var$activeToast = toast;
    // Animate in
    requestAnimationFrame(()=>{
        const inner = toast.querySelector("div");
        if (inner) {
            inner.style.opacity = "1";
            inner.style.transform = "translateX(-50%) translateY(0)";
        }
    });
    // Auto dismiss
    if (duration > 0) setTimeout(()=>{
        if (toast.parentNode) {
            const inner = toast.querySelector("div");
            if (inner) {
                inner.style.opacity = "0";
                inner.style.transform = "translateX(-50%) translateY(-20px)";
            }
            setTimeout(()=>toast.remove(), 300);
        }
    }, duration);
}
async function $397db21d7eb861a2$export$bfe1b0910e33c1e3(res) {
    try {
        const data = await res.json();
        if (data?.code === 505 || data?.message?.includes("high volume")) $397db21d7eb861a2$export$f6cef6fcf9ca4e17("Too many requests. Please wait a moment and try again.", "warning", 6000);
        else if (data?.message) $397db21d7eb861a2$export$f6cef6fcf9ca4e17(data.message, "error");
        else $397db21d7eb861a2$export$f6cef6fcf9ca4e17("Submission failed. Please try again.", "error");
    } catch  {
        $397db21d7eb861a2$export$f6cef6fcf9ca4e17("Submission failed. Please try again.", "error");
    }
}


document.addEventListener("DOMContentLoaded", ()=>{
    // Swiper init (scoped, no global const)
    if (window.Swiper) {
        const swiper = new Swiper(".mySwiper", {
            loop: true,
            speed: 1000,
            autoHeight: false,
            centeredSlides: true,
            spaceBetween: 40,
            navigation: {
                nextEl: ".swiper-button-next-custom",
                prevEl: ".swiper-button-prev-custom"
            },
            autoplay: {
                delay: 5000,
                disableOnInteraction: false,
                pauseOnMouseEnter: true
            },
            pagination: {
                el: ".swiper-pagination",
                clickable: true
            },
            breakpoints: {
                640: {
                    slidesPerView: 1,
                    spaceBetween: 24
                },
                768: {
                    slidesPerView: 1.25,
                    spaceBetween: 24
                },
                1080: {
                    slidesPerView: 1.25
                },
                1280: {
                    slidesPerView: 1.25
                },
                1440: {
                    slidesPerView: 1.5
                }
            }
        });
    }
    // make pills focusable for keyboard users
    document.querySelectorAll(".pill").forEach((p)=>{
        p.tabIndex = 0;
        p.addEventListener("keydown", (e)=>{
            if (e.key === "Enter" || e.key === " ") p.click();
        });
        p.addEventListener("click", ()=>{
            p.animate([
                {
                    transform: "translateY(0px)"
                },
                {
                    transform: "translateY(-8px)"
                },
                {
                    transform: "translateY(0px)"
                }
            ], {
                duration: 300
            });
        });
    });
    window.addEventListener("scroll", $7554f63cde7b4371$var$updateProgress);
    $7554f63cde7b4371$var$updateProgress();
});
// Call this once on load + on scroll/resize=====================
const $7554f63cde7b4371$var$updateProgress = ()=>{
    const items = document.querySelectorAll(".timeline-item");
    const progressLine = document.getElementById("progressLine");
    const mobileStepNumber = document.getElementById("mobileActiveStep");
    if (!items.length || !progressLine) return;
    let activeIndex = -1;
    // Mobile trigger tuning
    const isMobile = window.innerWidth < 768;
    const triggerLine = window.innerHeight * (isMobile ? 0.35 : 0.5);
    items.forEach((item, index)=>{
        const rect = item.getBoundingClientRect();
        const itemCenter = rect.top + rect.height / 2;
        if (itemCenter < triggerLine) activeIndex = index;
    });
    const activeCount = activeIndex + 1;
    /* -------------------------------
     ✅ PROGRESS LINE HEIGHT FIX
     Line ends exactly at step 07
  -------------------------------- */ const lineTop = progressLine.getBoundingClientRect().top + window.scrollY;
    const lastItem = items[items.length - 1];
    const lastCircle = lastItem.querySelector(".step-circle");
    const lastCircleCenter = lastCircle.getBoundingClientRect().top + lastCircle.offsetHeight / 2 + window.scrollY;
    const maxLineHeight = lastCircleCenter - lineTop;
    let currentHeight = 0;
    if (activeIndex >= 0) {
        const currentItem = items[Math.min(activeIndex, items.length - 1)];
        const currentCircle = currentItem.querySelector(".step-circle");
        const currentCenter = currentCircle.getBoundingClientRect().top + currentCircle.offsetHeight / 2 + window.scrollY;
        currentHeight = currentCenter - lineTop;
    }
    // Clamp height so it NEVER exceeds step 07
    progressLine.style.height = Math.max(0, Math.min(currentHeight, maxLineHeight)) + "px";
    /* -------------------------------
     Active styles (unchanged)
  -------------------------------- */ items.forEach((item, index)=>{
        const circles = item.querySelectorAll(".step-circle");
        const title = item.querySelector("h3");
        const isDone = index <= activeIndex;
        if (isDone) {
            circles.forEach((circle)=>{
                circle.classList.remove("text-gray-200");
                circle.classList.add("text-[#835CF5]");
            });
            if (title) {
                title.classList.remove("text-headingColor");
                title.classList.add("text-[#835CF5]");
            }
        } else {
            circles.forEach((circle)=>{
                circle.classList.remove("text-[#835CF5]");
                circle.classList.add("text-gray-200");
            });
            if (title) {
                title.classList.remove("text-[#835CF5]");
                title.classList.add("text-headingColor");
            }
        }
    });
    // Mobile number (unchanged)
    if (mobileStepNumber) mobileStepNumber.textContent = activeCount > 0 ? activeCount : 1;
};
[
    "load",
    "scroll",
    "resize"
].forEach((evt)=>{
    window.addEventListener(evt, ()=>{
        window.requestAnimationFrame($7554f63cde7b4371$var$updateProgress);
    });
});
// ================= Tabs with .tab-btn + .panel =================
(function() {
    const tabButtons = Array.from(document.querySelectorAll(".tab-btn"));
    const panels = Array.from(document.querySelectorAll(".panel"));
    function activateTab(button) {
        // deactivate all
        tabButtons.forEach((btn)=>{
            btn.classList.remove("bg-gradient-to-r", "from-mainPurple", "to-mainPurple", "text-white", "shadow-md");
            btn.classList.add("text-headingColor");
            btn.setAttribute("aria-selected", "false");
            btn.setAttribute("tabindex", "-1");
        });
        // hide all panels
        panels.forEach((p)=>{
            p.classList.add("hidden");
            p.setAttribute("aria-hidden", "true");
        });
        // activate chosen
        button.classList.remove("text-headingColor");
        button.classList.add("bg-gradient-to-r", "from-mainPurple", "to-mainPurple", "text-white", "shadow-md");
        button.setAttribute("aria-selected", "true");
        button.setAttribute("tabindex", "0");
        const id = button.getAttribute("data-tab");
        const panel = document.getElementById(id);
        if (panel) {
            panel.classList.remove("hidden");
            panel.setAttribute("aria-hidden", "false");
        }
    }
    // initial active
    const initial = tabButtons.find((b)=>b.getAttribute("aria-selected") === "true") || tabButtons[0];
    if (initial) activateTab(initial);
    tabButtons.forEach((btn)=>{
        btn.addEventListener("click", (e)=>{
            activateTab(e.currentTarget);
            e.currentTarget.focus();
        });
        // keyboard navigation: left/right arrows
        btn.addEventListener("keydown", (e)=>{
            const idx = tabButtons.indexOf(e.currentTarget);
            if (e.key === "ArrowRight") {
                const ni = (idx + 1) % tabButtons.length;
                tabButtons[ni].focus();
                activateTab(tabButtons[ni]);
                e.preventDefault();
            } else if (e.key === "ArrowLeft") {
                const ni = (idx - 1 + tabButtons.length) % tabButtons.length;
                tabButtons[ni].focus();
                activateTab(tabButtons[ni]);
                e.preventDefault();
            }
        });
    });
})();
// ========== Tech stack tabs (DATA-driven) ==========
(function() {
    // Categories data: label + tech items (name + simple SVG icon)
    const DATA = {
        ai: {
            label: "AI & Machine Learning",
            items: [
                {
                    name: "Python",
                    url: "https://ql-web-images.s3.us-east-2.amazonaws.com/ql-images/Frame%201948757215.svg"
                },
                {
                    name: "TensorFlow",
                    url: "https://ql-web-images.s3.us-east-2.amazonaws.com/ql-images/Frame%201948757219.svg"
                },
                {
                    name: "PyTorch",
                    url: "https://ql-web-images.s3.us-east-2.amazonaws.com/ql-images/Frame%201948757221.svg"
                },
                {
                    name: "LangChain",
                    url: "https://ql-web-images.s3.us-east-2.amazonaws.com/ql-images/Frame%201948757222.svg"
                },
                {
                    name: "RAG",
                    url: "https://ql-web-images.s3.us-east-2.amazonaws.com/ql-images/Frame%201948757223.svg"
                },
                {
                    name: "Keras",
                    url: "https://ql-web-images.s3.us-east-2.amazonaws.com/ql-images/Frame%201948757220.svg"
                },
                {
                    name: "Scikit Learn",
                    url: "https://ql-web-images.s3.us-east-2.amazonaws.com/ql-images/Frame%201948757225.svg"
                },
                {
                    name: "LlamaIndex",
                    url: "https://ql-web-images.s3.us-east-2.amazonaws.com/ql-images/llamaindex-color%201.svg"
                },
                {
                    name: "LoRA",
                    url: "https://ql-web-images.s3.us-east-2.amazonaws.com/ql-images/1631788636-logo-lora%201.svg"
                },
                {
                    name: "OpenAI GPT",
                    url: "https://ql-web-images.s3.us-east-2.amazonaws.com/ql-images/openai-chatgpt-logo-icon-free-png%201.svg"
                },
                {
                    name: "Claude",
                    url: "https://ql-web-images.s3.us-east-2.amazonaws.com/ql-images/claude-icon%201.svg"
                },
                {
                    name: "Gemini",
                    url: "https://ql-web-images.s3.us-east-2.amazonaws.com/ql-images/Frame%201948757226.svg"
                },
                {
                    name: "HuggingFace",
                    url: "https://ql-web-images.s3.us-east-2.amazonaws.com/ql-images/Frame%201948757217.svg"
                },
                {
                    name: "Stable Diffusion",
                    url: "https://ql-web-images.s3.us-east-2.amazonaws.com/ql-images/Frame%201948757214.svg"
                },
                {
                    name: "YOLOv8",
                    url: "https://ql-web-images.s3.us-east-2.amazonaws.com/ql-images/Frame%201948757215-1.svg"
                },
                {
                    name: "Bloom (BigScience)",
                    url: "https://ql-web-images.s3.us-east-2.amazonaws.com/ql-images/Frame%201948757215-2.svg"
                },
                {
                    name: "Flamingo",
                    url: "https://ql-web-images.s3.us-east-2.amazonaws.com/ql-images/logo-flamingo-isolated-tansparent-background-png-logo-flamingo-isolated-tansparent-background-png-generative-ai-274488745%201.svg"
                },
                {
                    name: "PaliGemma",
                    url: "https://ql-web-images.s3.us-east-2.amazonaws.com/ql-images/Frame%201948757229.svg"
                },
                {
                    name: "OpenCV",
                    url: "https://ql-web-images.s3.us-east-2.amazonaws.com/ql-images/Frame%201948757224.svg"
                },
                {
                    name: "Blockchain",
                    url: "https://ql-web-images.s3.us-east-2.amazonaws.com/ql-images/Frame%201948757226-1.svg"
                },
                {
                    name: "Integrated ML",
                    url: "https://ql-web-images.s3.us-east-2.amazonaws.com/ql-images/Frame%201948757217-1.svg"
                },
                {
                    name: "Federated Learning",
                    url: "https://ql-web-images.s3.us-east-2.amazonaws.com/ql-images/Frame%201948757214-1.svg"
                },
                {
                    name: "Docker",
                    url: "https://ql-web-images.s3.us-east-2.amazonaws.com/ql-images/62a9c7ab8ff6441a2952dad2%201.svg"
                },
                {
                    name: "MLOps",
                    url: "https://ql-web-images.s3.us-east-2.amazonaws.com/ql-images/green-and-white-modern-artificial-intelligence-presentation-1-5502170686247_l%201.svg"
                },
                {
                    name: "ONNX",
                    url: "https://ql-web-images.s3.us-east-2.amazonaws.com/ql-images/image%201108.svg"
                },
                {
                    name: "Multimodal AI",
                    url: "https://ql-web-images.s3.us-east-2.amazonaws.com/ql-images/image%201109.svg"
                },
                {
                    name: "AI Solutions",
                    url: "https://ql-web-images.s3.us-east-2.amazonaws.com/ql-images/Frame%201948757224-1.svg"
                },
                {
                    name: "IoT Analytics",
                    url: "https://ql-web-images.s3.us-east-2.amazonaws.com/ql-images/Frame%201948757226-2.svg"
                },
                {
                    name: "Guardrails",
                    url: "https://ql-web-images.s3.us-east-2.amazonaws.com/ql-images/guardrailtechnologieslogo1902693386%201.svg"
                },
                {
                    name: "PHI",
                    url: "https://ql-web-images.s3.us-east-2.amazonaws.com/ql-images/Frame%201948757214-2.svg"
                },
                {
                    name: "ML Pipelines",
                    url: "https://ql-web-images.s3.us-east-2.amazonaws.com/ql-images/Group%201597880595.svg"
                },
                {
                    name: "DPDP",
                    url: "https://ql-web-images.s3.us-east-2.amazonaws.com/ql-images/Frame%201948757215-3.svg"
                },
                {
                    name: "Ready Solutions",
                    url: "https://ql-web-images.s3.us-east-2.amazonaws.com/ql-images/image%201114.svg"
                },
                {
                    name: "Prompt Engineering",
                    url: "https://ql-web-images.s3.us-east-2.amazonaws.com/ql-images/Prompt-engineering-logos.svg"
                },
                {
                    name: "AI Security",
                    url: "https://ql-web-images.s3.us-east-2.amazonaws.com/ql-images/Frame%201948757224-2.svg"
                },
                {
                    name: "Mask R-CNN",
                    url: "https://ql-web-images.s3.us-east-2.amazonaws.com/ql-images/Frame%201948757143.svg"
                },
                {
                    name: "Real-time Video AI",
                    url: "https://ql-web-images.s3.us-east-2.amazonaws.com/ql-images/mtsai-video-ai%201.svg"
                },
                {
                    name: "Multi-agent & LLM",
                    url: "https://ql-web-images.s3.us-east-2.amazonaws.com/ql-images/Frame%201948757224-3.svg"
                }
            ]
        },
        mobile: {
            label: "Mobile",
            items: [
                {
                    name: "Swift",
                    url: `https://ql-web-images.s3.us-east-2.amazonaws.com/ql-images/swifttech.svg`
                },
                {
                    name: "Kotlin",
                    url: `https://ql-web-images.s3.us-east-2.amazonaws.com/ql-images/kotlinTransparent.webp`
                },
                {
                    name: "Flutter",
                    url: `https://ql-web-images.s3.us-east-2.amazonaws.com/ql-images/flutter.svg`
                },
                {
                    name: "React Native",
                    url: `https://ql-web-images.s3.us-east-2.amazonaws.com/ql-images/react.svg`
                },
                {
                    name: "Firebase",
                    url: `https://ql-web-images.s3.us-east-2.amazonaws.com/ql-images/firebase.svg`
                }
            ]
        },
        frontend: {
            label: "Web Frontend",
            items: [
                {
                    name: "Angular",
                    url: `https://ql-web-images.s3.us-east-2.amazonaws.com/ql-images/5847ea22cef1014c0b5e483.svg`
                },
                {
                    name: "Vue",
                    url: `https://ql-web-images.s3.us-east-2.amazonaws.com/ql-images/58482acecef1014c0b5e4a1e.svg`
                },
                {
                    name: "Python",
                    url: `https://ql-web-images.s3.us-east-2.amazonaws.com/ql-images/5848152fcef1014c0b5e4967.svg`
                },
                {
                    name: "SASS",
                    url: `https://ql-web-images.s3.us-east-2.amazonaws.com/ql-images/5968358.svg`
                },
                {
                    name: "CSS3",
                    url: `https://ql-web-images.s3.us-east-2.amazonaws.com/ql-images/Frame1948757207.svg`
                },
                {
                    name: "Material-ui",
                    url: `https://ql-web-images.s3.us-east-2.amazonaws.com/ql-images/Frame1948757208.svg`
                },
                {
                    name: "Tailwind CSS",
                    url: `https://ql-web-images.s3.us-east-2.amazonaws.com/ql-images/Frame1948757209.svg`
                },
                {
                    name: "Next.js",
                    url: `https://ql-web-images.s3.us-east-2.amazonaws.com/ql-images/Frame1948757210.svg`
                },
                {
                    name: "Redux",
                    url: `https://ql-web-images.s3.us-east-2.amazonaws.com/ql-images/Frame1948757211.svg`
                },
                {
                    name: "Zustand",
                    url: `https://ql-web-images.s3.us-east-2.amazonaws.com/ql-images/Frame1948757212.svg`
                },
                {
                    name: "React Js",
                    url: `https://ql-web-images.s3.us-east-2.amazonaws.com/ql-images/React-iconsvg.svg`
                },
                {
                    name: "PHP",
                    url: `https://ql-web-images.s3.us-east-2.amazonaws.com/ql-images/php.svg`
                }
            ]
        },
        backend: {
            label: "Backend & APIs",
            items: [
                {
                    name: "Node.js",
                    url: `https://ql-web-images.s3.us-east-2.amazonaws.com/ql-images/nodeJS.svg`
                },
                {
                    name: "Express.js",
                    url: `https://ql-web-images.s3.us-east-2.amazonaws.com/ql-images/express.svg`
                },
                {
                    name: "Python",
                    url: `https://ql-web-images.s3.us-east-2.amazonaws.com/ql-images/pythonenew.svg`
                },
                {
                    name: "Java",
                    url: `https://ql-web-images.s3.us-east-2.amazonaws.com/ql-images/java.svg`
                },
                {
                    name: "PHP",
                    url: `https://ql-web-images.s3.us-east-2.amazonaws.com/ql-images/php.svg`
                },
                {
                    name: ".NET Core",
                    url: `https://ql-web-images.s3.us-east-2.amazonaws.com/ql-images/dotnet.svg`
                }
            ]
        },
        cloud: {
            label: "Cloud & DevOps",
            items: [
                {
                    name: "AWS",
                    url: `https://ql-web-images.s3.us-east-2.amazonaws.com/ql-images/AWS.svg`
                },
                {
                    name: "Google Cloud",
                    url: `https://ql-web-images.s3.us-east-2.amazonaws.com/ql-images/GoogleCloud.svg`
                },
                {
                    name: "Microsoft Azure",
                    url: `https://ql-web-images.s3.us-east-2.amazonaws.com/ql-images/MicrosoftAzure.svg`
                },
                {
                    name: "PostgreSQL",
                    url: `https://ql-web-images.s3.us-east-2.amazonaws.com/ql-images/PostgreSQL.svg`
                },
                {
                    name: "MySQL",
                    url: `https://ql-web-images.s3.us-east-2.amazonaws.com/ql-images/MySQL.svg`
                },
                {
                    name: "MongoDB",
                    url: `https://ql-web-images.s3.us-east-2.amazonaws.com/ql-images/MongoDB.svg`
                },
                {
                    name: "CI/CD",
                    url: `https://ql-web-images.s3.us-east-2.amazonaws.com/ql-images/What-is-CICD.svg`
                },
                {
                    name: "SonarQube",
                    url: `https://ql-web-images.s3.us-east-2.amazonaws.com/ql-images/SonarQube.svg`
                },
                {
                    name: "Docker",
                    url: `https://ql-web-images.s3.us-east-2.amazonaws.com/ql-images/Docker.svg`
                },
                {
                    name: "Nginx",
                    url: `https://ql-web-images.s3.us-east-2.amazonaws.com/ql-images/Nginx.svg`
                },
                {
                    name: "Loki",
                    url: `https://ql-web-images.s3.us-east-2.amazonaws.com/ql-images/loki2.webp`
                },
                {
                    name: "Redis",
                    url: `https://ql-web-images.s3.us-east-2.amazonaws.com/ql-images/Redis.svg`
                },
                {
                    name: "Git",
                    url: `https://ql-web-images.s3.us-east-2.amazonaws.com/ql-images/Git.svg`
                },
                {
                    name: "Kubernetes",
                    url: `https://ql-web-images.s3.us-east-2.amazonaws.com/ql-images/Kubernetes.svg`
                },
                {
                    name: "Terraform",
                    url: `https://ql-web-images.s3.us-east-2.amazonaws.com/ql-images/Terraform.svg`
                },
                {
                    name: "Serverless Architecture",
                    url: `https://ql-web-images.s3.us-east-2.amazonaws.com/ql-images/ServerlessArchitecture.svg`
                },
                {
                    name: "Prometheus",
                    url: `https://ql-web-images.s3.us-east-2.amazonaws.com/ql-images/Prometheus.svg`
                },
                {
                    name: "Grafana",
                    url: `https://ql-web-images.s3.us-east-2.amazonaws.com/ql-images/Grafana.svg`
                }
            ]
        },
        db: {
            label: "Databases",
            items: [
                {
                    name: "SQLite",
                    url: `https://ql-web-images.s3.us-east-2.amazonaws.com/ql-images/SQLite.svg`
                },
                {
                    name: "Cassandra",
                    url: `https://ql-web-images.s3.us-east-2.amazonaws.com/ql-images/Cassandra.svg`
                },
                {
                    name: "Firebase",
                    url: `https://ql-web-images.s3.us-east-2.amazonaws.com/ql-images/Firebase.svg`
                },
                {
                    name: "PostgreSQL",
                    url: `https://ql-web-images.s3.us-east-2.amazonaws.com/ql-images/PostgreSQL2.svg`
                },
                {
                    name: "MySQL",
                    url: `https://ql-web-images.s3.us-east-2.amazonaws.com/ql-images/MySQL2.svg`
                },
                {
                    name: "MongoDB",
                    url: `https://ql-web-images.s3.us-east-2.amazonaws.com/ql-images/MongoDB2.svg`
                },
                {
                    name: "DynamoDB",
                    url: `https://ql-web-images.s3.us-east-2.amazonaws.com/ql-images/DynamoDB2.svg`
                },
                {
                    name: "MariaDB",
                    url: `https://ql-web-images.s3.us-east-2.amazonaws.com/ql-images/MariaDB2.svg`
                },
                {
                    name: "Elastic Search",
                    url: `https://ql-web-images.s3.us-east-2.amazonaws.com/ql-images/ElasticSearch.svg`
                },
                {
                    name: "Neo4j",
                    url: `https://ql-web-images.s3.us-east-2.amazonaws.com/ql-images/Neo4j.svg`
                },
                {
                    name: "Firestore",
                    url: `https://ql-web-images.s3.us-east-2.amazonaws.com/ql-images/Firestore.svg`
                },
                {
                    name: "SQLserver",
                    url: `https://ql-web-images.s3.us-east-2.amazonaws.com/ql-images/SQLserver.svg`
                }
            ]
        }
    };
    // elements
    const tabsContainer = document.getElementById("tabs");
    const tilesGrid = document.getElementById("tilesGrid");
    if (!tabsContainer || !tilesGrid) return;
    // render tabs from data (keeps DOM in sync)
    const keys = Object.keys(DATA);
    tabsContainer.innerHTML = "";
    keys.forEach((k)=>{
        const btn = document.createElement("button");
        btn.type = "button";
        btn.className = "tab-btn text-[#101010] font-normal px-4 py-3 text-lg font-publicSans rounded-2xl whitespace-nowrap";
        btn.setAttribute("data-key", k);
        btn.textContent = DATA[k].label;
        btn.setAttribute("aria-pressed", "false");
        btn.addEventListener("click", ()=>selectTab(k, btn));
        btn.addEventListener("keydown", (e)=>{
            if (e.key === "Enter" || e.key === " ") {
                e.preventDefault();
                selectTab(k, btn);
            }
        });
        tabsContainer.appendChild(btn);
    });
    // function to render tiles
    function renderTiles(items) {
        tilesGrid.innerHTML = "";
        items.forEach((it)=>{
            const tile = document.createElement("div");
            tile.className = "tech-tile";
            tile.innerHTML = `
      <div class="mb-2 h-8 flex items-center justify-center" aria-hidden="true">
        <img 
          src="${it.url}" 
          alt="${it.name}" 
          class=" object-contain h-full"
          loading="lazy"
        />
      </div>
      <div class="text-base font-normal text-headingColor">${it.name}</div>
    `;
            tilesGrid.appendChild(tile);
        });
    }
    // position active pill over button (currently just calculates; extend if needed)
    function positionPill(btn) {
        const wrapper = document.getElementById("tabsWrapper");
        if (!wrapper || !btn) return;
        const wrapRect = wrapper.getBoundingClientRect();
        const btnRect = btn.getBoundingClientRect();
        const left = btnRect.left - wrapRect.left + 6; // 6px wrapper padding
        const width = btnRect.width;
    }
    function selectTab(key, btnEl) {
        document.querySelectorAll(".tab-btn").forEach((b)=>{
            const isActive = b === btnEl;
            b.setAttribute("aria-pressed", isActive ? "true" : "false");
            b.classList.toggle("bg-white", isActive);
            b.classList.toggle("text-black", isActive);
            b.classList.toggle("text-[#101010]", !isActive);
            // remove hover bg for active tab
            if (isActive) b.classList.remove("hover:bg-gray-50");
            else b.classList.add("hover:bg-gray-50");
        });
        positionPill(btnEl);
        renderTiles(DATA[key].items);
    }
    // init: pick 'mobile' tab or first
    const defaultKey = "ai" in DATA ? "ai" : keys[0];
    const defaultBtn = Array.from(document.querySelectorAll(".tab-btn")).find((b)=>b.dataset.key === defaultKey);
    setTimeout(()=>{
        selectTab(defaultKey, defaultBtn || document.querySelector(".tab-btn"));
    }, 50);
    // reposition on resize
    window.addEventListener("resize", ()=>{
        const active = document.querySelector('.tab-btn[aria-pressed="true"]');
        if (active) positionPill(active);
    });
})();
// === Read More function ===================
// ================== Accordion (data-accordion-button) =================
(function() {
    const buttons = Array.from(document.querySelectorAll("[data-accordion-button]"));
    if (!buttons.length) return;
    let openPanel = null;
    function getTextEl(btn) {
        // works whether text is on button or inside span
        return btn.querySelector("[data-accordion-title]") || btn;
    }
    function open(panel, btn) {
        // close previously open panel
        if (openPanel && openPanel !== panel) {
            const prevBtn = openPanel.previousElementSibling.querySelector("[data-accordion-button]");
            close(openPanel, prevBtn);
        }
        panel.style.maxHeight = panel.scrollHeight + "px";
        btn.setAttribute("aria-expanded", "true");
        btn.classList.add("bg-[#fff]");
        // ✅ font weight – ALWAYS works
        const textEl = getTextEl(btn);
        // textEl.classList.add("font-semibold");
        textEl.classList.remove("font-normal");
        const icon = btn.querySelector("svg");
        if (icon) icon.style.transform = "rotate(45deg)";
        openPanel = panel;
    }
    function close(panel, btn) {
        panel.style.maxHeight = panel.offsetHeight + "px";
        requestAnimationFrame(()=>panel.style.maxHeight = "0px");
        btn.setAttribute("aria-expanded", "false");
        btn.classList.remove("bg-[#fff]");
        // ✅ reset font weight
        const textEl = getTextEl(btn);
        // textEl.classList.remove("font-semibold");
        textEl.classList.add("font-normal");
        const icon = btn.querySelector("svg");
        if (icon) icon.style.transform = "rotate(0deg)";
        if (openPanel === panel) openPanel = null;
    }
    buttons.forEach((btn)=>{
        const panelId = btn.getAttribute("aria-controls");
        const panel = document.getElementById(panelId);
        if (!panel) return;
        panel.style.maxHeight = "0px";
        // 🔒 normalize initial state for ALL cards
        const textEl = getTextEl(btn);
        textEl.classList.remove("font-semibold");
        textEl.classList.add("font-normal");
        btn.addEventListener("click", ()=>{
            const expanded = btn.getAttribute("aria-expanded") === "true";
            expanded ? close(panel, btn) : open(panel, btn);
        });
        btn.addEventListener("keydown", (e)=>{
            if (e.key === "ArrowDown") {
                e.preventDefault();
                buttons[(buttons.indexOf(btn) + 1) % buttons.length].focus();
            } else if (e.key === "ArrowUp") {
                e.preventDefault();
                const idx = buttons.indexOf(btn) - 1;
                buttons[idx < 0 ? buttons.length - 1 : idx].focus();
            }
        });
        panel.addEventListener("transitionend", (e)=>{
            if (e.propertyName !== "max-height") return;
            panel.style.maxHeight = btn.getAttribute("aria-expanded") === "true" ? "none" : "0px";
        });
    });
})();
// ======= Form submit =========
// ===============================
async function $7554f63cde7b4371$var$loadCountryCodes() {
    try {
        const response = await fetch(`${"https://quokkalabs.com"}/blog/api/metadata?country_codes=true`);
        const data = await response.json();
        const countrySelect = document.getElementById("countryCode");
        // Clear existing options
        countrySelect.innerHTML = "";
        data.data.country_codes.forEach((country)=>{
            const option = document.createElement("option");
            option.value = country.value;
            option.textContent = country.label;
            option.dataset.code = country.value;
            option.dataset.label = country.label;
            countrySelect.appendChild(option);
        });
        // Default India selected
        countrySelect.value = "+91";
        // Show only code initially
        $7554f63cde7b4371$var$collapseToCode();
    } catch (error) {
        console.error("Error loading country codes:", error);
    }
}
const $7554f63cde7b4371$var$countrySelect = document.getElementById("countryCode");
let $7554f63cde7b4371$var$lastOpenedAt = 0;
function $7554f63cde7b4371$var$handleOpen() {
    $7554f63cde7b4371$var$restoreLabels();
    $7554f63cde7b4371$var$lastOpenedAt = Date.now();
}
function $7554f63cde7b4371$var$handleCloseOrSelect() {
    if (Date.now() - $7554f63cde7b4371$var$lastOpenedAt < 300) return;
    $7554f63cde7b4371$var$collapseToCode();
}
function $7554f63cde7b4371$var$restoreLabels() {
    Array.from($7554f63cde7b4371$var$countrySelect.options).forEach((option)=>{
        option.textContent = option.dataset.label;
    });
}
function $7554f63cde7b4371$var$collapseToCode() {
    $7554f63cde7b4371$var$restoreLabels();
    const selectedOption = $7554f63cde7b4371$var$countrySelect.options[$7554f63cde7b4371$var$countrySelect.selectedIndex];
    if (selectedOption) selectedOption.textContent = selectedOption.dataset.code;
}
// Show full list while opening
$7554f63cde7b4371$var$countrySelect?.addEventListener("mousedown", $7554f63cde7b4371$var$handleOpen);
$7554f63cde7b4371$var$countrySelect?.addEventListener("focus", $7554f63cde7b4371$var$handleOpen);
// Show only code after selection, click, or blur
$7554f63cde7b4371$var$countrySelect?.addEventListener("change", $7554f63cde7b4371$var$collapseToCode);
$7554f63cde7b4371$var$countrySelect?.addEventListener("blur", $7554f63cde7b4371$var$collapseToCode);
$7554f63cde7b4371$var$countrySelect?.addEventListener("click", $7554f63cde7b4371$var$handleCloseOrSelect);
// Load dropdown
$7554f63cde7b4371$var$loadCountryCodes();
// Usage in form submit
function $7554f63cde7b4371$var$getCountryCode() {
    const selectedOption = $7554f63cde7b4371$var$countrySelect.options[$7554f63cde7b4371$var$countrySelect.selectedIndex];
    return selectedOption?.dataset.code || "";
}
// form submit function and captcha related code
// =============================================
let $7554f63cde7b4371$var$savedCaptchaCode = "";
// CAPTCHA API LOAD
const $7554f63cde7b4371$var$createCaptchaImage = async ()=>{
    const captchaBox = document.getElementById("captchaImage");
    if (captchaBox) captchaBox.innerHTML = '<div class="w-[9.375rem] h-[3.125rem] border border-white animate-pulse"></div>';
    try {
        const response = await fetch(`${"https://quokkalabs.com"}/blog/api/captcha`, {
            method: "GET"
        });
        if (!response.ok) throw new Error("Captcha API failed");
        const result = await response.json();
        $7554f63cde7b4371$var$savedCaptchaCode = result.captcha_0 || "";
        if (captchaBox) captchaBox.innerHTML = `
        <img
          src="${result.image_url?.replace('http:', 'https:')}"
          alt="captcha"
          class="h-[3.125rem] w-[8.375rem] object-contain rounded"
        />
      `;
    } catch (error) {
        console.error("Captcha Error:", error);
        if (captchaBox) captchaBox.innerHTML = '<div class="text-white text-xs">Captcha failed</div>';
    }
};
window.onload = ()=>$7554f63cde7b4371$var$createCaptchaImage();
window.createCaptchaImage = $7554f63cde7b4371$var$createCaptchaImage;
// HELPERS
const $7554f63cde7b4371$var$focusField = (id)=>{
    const el = document.getElementById(id);
    if (el) el.focus();
};
// ===============================
// VALIDATIONS
// ===============================
const $7554f63cde7b4371$var$validateName = (name)=>{
    if (!name || name.length < 3) {
        alert("Please enter a valid full name (at least 3 characters).");
        $7554f63cde7b4371$var$focusField("fullName");
        return false;
    }
    return true;
};
const $7554f63cde7b4371$var$validateEmail = (email)=>{
    if (!email) {
        alert("Please enter your email address.");
        $7554f63cde7b4371$var$focusField("email");
        return false;
    }
    const pattern = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/i;
    if (!pattern.test(email)) {
        alert("Please enter a valid email address (e.g. name@example.com).");
        $7554f63cde7b4371$var$focusField("email");
        return false;
    }
    // Count dots in the local part (before @)
    const localPart = email.split("@")[0];
    const dotCount = (localPart.match(/\./g) || []).length;
    if (dotCount > 2) {
        alert("Please enter a valid email address (e.g. name@example.com).");
        $7554f63cde7b4371$var$focusField("email");
        return false;
    }
    return true;
};
const $7554f63cde7b4371$var$validatePhone = (phone)=>{
    const cleaned = phone.replace(/\D/g, "");
    if (cleaned.length < 7 || cleaned.length > 15) {
        alert("Please enter a valid phone number (7 to 15 digits) with country code.");
        $7554f63cde7b4371$var$focusField("Phone_number");
        return null;
    }
    return cleaned;
};
const $7554f63cde7b4371$var$validateCaptcha = ()=>{
    const captchaInput = document.getElementById("captchaInput")?.value.trim();
    if (!captchaInput) {
        alert("Please enter the CAPTCHA code shown in the image.");
        $7554f63cde7b4371$var$focusField("captchaInput");
        return false;
    }
    return true;
};
const $7554f63cde7b4371$var$validateMessage = (message)=>{
    const trimmedMessage = message?.trim();
    // Optional field
    if (!trimmedMessage) return true;
    if (trimmedMessage.length < 10) {
        alert("Please enter a valid message (at least 10 characters).");
        $7554f63cde7b4371$var$focusField("message");
        return false;
    }
    return true;
};
// FORM SUBMIT
const $7554f63cde7b4371$var$FormSubmit = async (e)=>{
    e.preventDefault();
    const submitBtn = document.getElementById("form-button");
    if (submitBtn.disabled) return;
    // Honeypot check
    const honeypot = document.getElementById("honeypot");
    if (honeypot && honeypot.value !== "") return;
    const name = document.getElementById("fullName")?.value.trim();
    const email = document.getElementById("email")?.value.trim();
    const phoneRaw = document.getElementById("Phone_number")?.value.trim();
    const companyName = document.getElementById("company_name")?.value.trim();
    const message = document.getElementById("project")?.value.trim() || "";
    const captchaInput = document.getElementById("captchaInput")?.value.trim();
    const countrySelect = document.getElementById("countryCode");
    const areaOfInterest = document.getElementById("area_of_interest")?.value || "";
    const countryCode = countrySelect?.value || "";
    // Validations
    if (!$7554f63cde7b4371$var$validateName(name)) return;
    if (!$7554f63cde7b4371$var$validateEmail(email)) return;
    if (!$7554f63cde7b4371$var$validateMessage(message)) return;
    const cleanedPhone = $7554f63cde7b4371$var$validatePhone(phoneRaw || "");
    if (!cleanedPhone) return;
    if (!$7554f63cde7b4371$var$validateCaptcha()) return;
    submitBtn.disabled = true;
    submitBtn.textContent = "Submitting...";
    const formData = new FormData();
    formData.append("name", name);
    formData.append("email", email);
    formData.append("phone", cleanedPhone);
    formData.append("company_name", companyName);
    formData.append("country_code", countryCode);
    formData.append("description", message);
    formData.append("area_of_interest", areaOfInterest);
    // Captcha API values
    formData.append("captcha_0", $7554f63cde7b4371$var$savedCaptchaCode);
    formData.append("captcha_1", captchaInput);
    // Extra fields
    formData.append("source", "contact-us");
    formData.append("user_agent", navigator.userAgent);
    try {
        const response = await fetch(`${"https://quokkalabs.com"}/blog/api/contact-us`, {
            method: "POST",
            body: formData
        });
        if (!response.ok) throw new Error("Form failed");
        const result = await response.json();
        // Save data
        if (result?.data?.name) localStorage.setItem("contact_name", result.data.name);
        if (result?.data?.email) localStorage.setItem("contact_email", result.data.email);
        // Redirect keep same
        window.location.href = "/thankyou";
    } catch (error) {
        console.error(error);
        submitBtn.disabled = false;
        submitBtn.textContent = "Submit";
        $7554f63cde7b4371$var$createCaptchaImage();
    }
};
window.FormSubmit = $7554f63cde7b4371$var$FormSubmit;
// PAGE CACHE FIX
window.addEventListener("pageshow", (event)=>{
    if (event.persisted) window.location.reload();
});
// THANK YOU PAGE DATA
document.addEventListener("DOMContentLoaded", ()=>{
    const userName = document.getElementById("userName");
    const userEmail = document.getElementById("userEmail");
    if (userName) userName.textContent = localStorage.getItem("contact_name") || "No Name Found";
    if (userEmail) userEmail.textContent = localStorage.getItem("contact_email") || "No Email Found";
});
// ========== AI partners section ==========
document.addEventListener("DOMContentLoaded", function() {
    const content = {
        openai: {
            icon: "https://ql-web-images.s3.us-east-2.amazonaws.com/ql-images/openai-new-mobile.svg",
            text: `<p class="font-semibold text-headingColor text-h5 font-publicSans mb-2">OpenAI</p>
             <p class="font-normal text-headingLight text-body-large font-publicSans">
               Quokka Labs, an OpenAI Partner, builds GPT-powered solutions for automation, decision intelligence, and natural language experiences.
             </p>`
        },
        vercel: {
            icon: "https://ql-web-images.s3.us-east-2.amazonaws.com/ql-images/Anthropic-new-mobile.svg",
            text: `<p class="font-semibold text-headingColor text-h5 font-publicSans mb-2">Anthropic</p>
             <p class="font-normal text-headingLight text-body-large font-publicSans">
               As an Anthropic Claude Partner, Quokka Labs delivers safe, context-aware AI assistants with a focus on trust and compliance.
             </p>`
        },
        aws: {
            icon: "https://ql-web-images.s3.us-east-2.amazonaws.com/ql-images/microsoft-new-mobile.svg",
            text: `<p class="font-semibold text-headingColor text-h5 font-publicSans mb-2">Microsoft Azure</p>
             <p class="font-normal text-headingLight text-body-large font-publicSans">
               Our partnership with Microsoft Azure ensures state-of-the-art cloud and AI solutions, spanning automation, security, and enterprise-grade compliance.
             </p>`
        },
        gcp: {
            icon: "https://upload.wikimedia.org/wikipedia/commons/9/93/Amazon_Web_Services_Logo.svg",
            text: `<p class="font-semibold text-headingColor text-h5 font-publicSans mb-2">AWS</p>
             <p class="font-normal text-headingLight text-body-large font-publicSans">
               Quokka Labs, an AWS Premier Partner, brings 30+ AI experts with a deep focus on digital resilience, AI-powered modernization, and enterprise scalability.
             </p>`
        },
        databricks: {
            icon: "https://ql-web-images.s3.us-east-2.amazonaws.com/ql-images/databricks-new-mobile.svg",
            text: `<p class="font-semibold text-headingColor text-h5 font-publicSans mb-2">Databricks</p>
             <p class="font-normal text-headingLight text-body-large font-publicSans">
               As a Databricks Elite Consulting Partner, with 30+ certified professionals, we empower clients with advanced data engineering, analytics, and AI pipeline automation.
             </p>`
        },
        microsoft: {
            icon: "https://ql-web-images.s3.us-east-2.amazonaws.com/ql-images/gcloud-new-mobile.svg",
            text: `<p class="font-semibold text-headingColor text-h5 font-publicSans mb-2">Google Cloud</p>
             <p class="font-normal text-headingLight text-body-large font-publicSans">
               A Google Cloud Premier Partner since 2012, Quokka Labs delivers safe, cloud-native solutions for GenAI, Agentic AI, and data-driven innovation.
             </p>`
        }
    };
    const iconEl = document.getElementById("tab-icon");
    const textEl = document.getElementById("tab-text");
    function setTab(tab) {
        if (iconEl && textEl && content[tab]) {
            iconEl.src = content[tab].icon;
            textEl.innerHTML = content[tab].text;
        }
    }
    // Expose if you still need it globally
    window.setTab = setTab;
    document.querySelectorAll(".tab-button").forEach((el)=>{
        el.addEventListener("click", ()=>{
            const current = document.querySelector(".tab-button.activePartners");
            if (current) current.classList.remove("activePartners");
            el.classList.add("activePartners");
            const tab = el.getAttribute("data-tab");
            if (tab) setTab(tab);
        });
    });
    // Make first tab active on load
    const firstTab = document.querySelector(".tab-button");
    if (firstTab) {
        firstTab.classList.add("activePartners");
        const tab = firstTab.getAttribute("data-tab");
        if (tab) setTab(tab);
    }
});
// ==== mobile accordion focus toggle =====// ================= FAQ Accordion Section =================
(()=>{
    document.addEventListener("DOMContentLoaded", function() {
        const triggers = document.querySelectorAll(".faq-trigger");
        const accordions = document.querySelectorAll(".mobile_accordion");
        if (!triggers.length) return;
        let currentOpen = null;
        let currentBtn = null;
        function clearFocus() {
            accordions.forEach((el)=>el.classList.remove("is-focused"));
        }
        triggers.forEach((trigger)=>{
            trigger.addEventListener("click", function(e) {
                e.stopPropagation();
                const targetId = this.getAttribute("data-target");
                const targetContent = document.getElementById(targetId);
                const iconContainer = this.querySelector(".chevron-rotate");
                const accordionBtn = this.closest(".mobile_accordion");
                if (!targetContent || !iconContainer || !accordionBtn) return;
                const plusIcon = iconContainer.querySelector(".plus-icon");
                const minusIcon = iconContainer.querySelector(".minus-icon");
                // 🔴 Close previously open FAQ
                if (currentOpen && currentOpen !== targetContent) {
                    currentOpen.style.maxHeight = null;
                    currentOpen.classList.remove("open");
                    if (currentBtn) currentBtn.classList.remove("is-focused");
                    const prevIcon = currentBtn?.querySelector(".chevron-rotate");
                    if (prevIcon) {
                        prevIcon.classList.remove("open");
                        prevIcon.querySelector(".plus-icon")?.classList.remove("hidden");
                        prevIcon.querySelector(".minus-icon")?.classList.add("hidden");
                    }
                    currentOpen = null;
                    currentBtn = null;
                }
                // 🟡 Toggle current
                if (targetContent.classList.contains("open")) {
                    // CLOSE
                    targetContent.style.maxHeight = null;
                    targetContent.classList.remove("open");
                    iconContainer.classList.remove("open");
                    plusIcon?.classList.remove("hidden");
                    minusIcon?.classList.add("hidden");
                    accordionBtn.classList.remove("is-focused");
                    currentOpen = null;
                    currentBtn = null;
                } else {
                    // OPEN
                    clearFocus();
                    targetContent.classList.add("open");
                    targetContent.style.maxHeight = targetContent.scrollHeight + "px";
                    iconContainer.classList.add("open");
                    plusIcon?.classList.add("hidden");
                    minusIcon?.classList.remove("hidden");
                    accordionBtn.classList.add("is-focused");
                    currentOpen = targetContent;
                    currentBtn = accordionBtn;
                    const inner = targetContent.querySelector("div");
                    if (inner) {
                        inner.classList.add("fade-in-up");
                        setTimeout(()=>inner.classList.remove("fade-in-up"), 300);
                    }
                }
            });
        });
        // 🔵 Click outside → close focus
        document.addEventListener("click", ()=>{
            clearFocus();
            currentOpen = null;
            currentBtn = null;
        });
    });
})();
// ============= Looping marquee text ============
(()=>{
    class LoopingText {
        constructor(container, speed = 0.05, direction = -1){
            this.el = container;
            this.speed = speed; // Lower = slower
            this.direction = direction; // -1 left, 1 right
            this.position = 0;
            this.init();
            this.loop();
        }
        init() {
            this.el.style.cssText = "position: relative; display: inline-flex; white-space: nowrap;";
            const clone = this.el.children[1];
            if (clone) clone.style.cssText = `position: absolute; left: ${-100 * this.direction}%`;
        }
        loop() {
            this.position += this.speed;
            if (this.position >= 100) this.position = 0;
            this.el.style.transform = `translateX(${this.position * this.direction}%)`;
            requestAnimationFrame(()=>this.loop());
        }
    }
    document.querySelectorAll(".loop-container").forEach((el)=>{
        new LoopingText(el, 0.05, -1); // change 0.02 = slower speed
    });
})();
// ============= Blog tabs (.tab-item) ============
(()=>{
    // Find every independent tab section on the page
    document.querySelectorAll("[data-tab-section]").forEach((section)=>{
        const tabItems = section.querySelectorAll(".tab-item");
        const tabContents = section.querySelectorAll(".tab-content");
        if (!tabItems.length) return;
        tabItems.forEach((item)=>{
            item.addEventListener("click", ()=>{
                const tabId = item.getAttribute("data-tab");
                // Reset all tab items within THIS section only
                tabItems.forEach((el)=>{
                    el.classList.remove("active", "gradiantBorderLine", "gradiantBorderLineFintech");
                    el.classList.add("border-gray-300");
                    const innerBox = el.querySelector(".tab_contentBoxFintech, .tab_contentBox");
                    if (innerBox) innerBox.classList.remove("bg-white", "bg-purple-200");
                });
                // Hide all tab contents within THIS section only
                tabContents.forEach((el)=>{
                    el.classList.add("hidden");
                    el.classList.remove("is-active");
                });
                // Activate the clicked tab item
                item.classList.add("active", "gradiantBorderLineFintech");
                item.classList.remove("border-gray-300");
                const innerBox = item.querySelector(".tab_contentBoxFintech, .tab_contentBox");
                if (innerBox) innerBox.classList.add("bg-white");
                // Show the matching tab content
                const target = section.querySelector(`#${tabId}`);
                if (target) {
                    target.classList.remove("hidden");
                    target.classList.add("is-active");
                }
            });
        });
    });
})();
// swiper js
(()=>{
    const aiInvationSlider = ()=>{
        const sliderEl = document.querySelector(".aiInvationSlider");
        if (!sliderEl) return;
        const prevEl = sliderEl.querySelector(".swiper-button-prev") || ".aiInvationSlider .swiper-button-prev";
        const nextEl = sliderEl.querySelector(".swiper-button-next") || ".aiInvationSlider .swiper-button-next";
        new Swiper(sliderEl, {
            effect: "coverflow",
            grabCursor: true,
            centeredSlides: true,
            slidesPerView: 4,
            coverflowEffect: {
                rotate: -10,
                stretch: -20,
                depth: 150,
                modifier: 1,
                slideShadows: false
            },
            loop: true,
            navigation: {
                nextEl: nextEl,
                prevEl: prevEl
            },
            breakpoints: {
                320: {
                    slidesPerView: 1
                },
                640: {
                    slidesPerView: 2
                },
                768: {
                    slidesPerView: 3
                },
                1024: {
                    slidesPerView: 4
                },
                1440: {
                    slidesPerView: 4
                },
                1920: {
                    slidesPerView: 4
                }
            }
        });
    };
    const loadSwiper = ()=>{
        if (typeof Swiper !== "undefined") {
            aiInvationSlider();
            return;
        }
        const scriptSrc = "https://cdn.quokkalabs.com/js/swiper-bundle.min.js";
        let script = document.querySelector(`script[src="${scriptSrc}"]`);
        if (!script) {
            script = document.createElement("script");
            script.src = scriptSrc;
            script.crossOrigin = "anonymous";
            document.head.appendChild(script);
        }
        if (typeof Swiper !== "undefined") aiInvationSlider();
        else script.addEventListener("load", ()=>{
            aiInvationSlider();
        });
    };
    if (document.readyState === "complete" || document.readyState === "interactive") loadSwiper();
    else window.addEventListener("DOMContentLoaded", loadSwiper);
})();
// ==============
(()=>{
    const gradiantTestClass = document.querySelectorAll(".textColorsGradiant");
    gradiantTestClass.forEach((el)=>{
        el.addEventListener("click", (e)=>{
            // Remove the active class from all other elements
            gradiantTestClass.forEach((btn)=>{
                if (btn !== el) btn.classList.remove("gradiantTextColors");
            });
            // Toggle class on the clicked element
            el.classList.toggle("gradiantTextColors");
            e.stopPropagation();
        });
    });
})();
// ================= Accordion Section =================
(()=>{
    document.addEventListener("DOMContentLoaded", function() {
        const triggers = document.querySelectorAll(".faq-trigger_workflow");
        let currentOpen = null;
        triggers.forEach((trigger)=>{
            trigger.addEventListener("click", function() {
                const targetId = this.getAttribute("data-target");
                const targetContent = document.getElementById(targetId);
                const iconContainer = this.querySelector(".chevron-rotate");
                // ✅ plus/minus icons support
                const plusIcon = iconContainer?.querySelector(".plus-icon");
                const minusIcon = iconContainer?.querySelector(".minus-icon");
                // --- CLOSE previously open FAQ ---
                if (currentOpen && currentOpen !== targetContent) {
                    const prevBtn = currentOpen.previousElementSibling;
                    const prevIcon = prevBtn.querySelector(".chevron-rotate");
                    // reset previous icon rotation
                    prevIcon.classList.remove("open");
                    // reset plus/minus
                    const prevPlus = prevIcon.querySelector(".plus-icon");
                    const prevMinus = prevIcon.querySelector(".minus-icon");
                    if (prevPlus && prevMinus) {
                        prevPlus.classList.remove("hidden");
                        prevMinus.classList.add("hidden");
                    }
                    // collapse previous content
                    currentOpen.style.maxHeight = null;
                    currentOpen.classList.remove("open");
                }
                // --- TOGGLE current clicked FAQ ---
                if (targetContent.classList.contains("open")) {
                    // closing
                    targetContent.style.maxHeight = null;
                    targetContent.classList.remove("open");
                    iconContainer.classList.remove("open");
                    if (plusIcon && minusIcon) {
                        plusIcon.classList.remove("hidden");
                        minusIcon.classList.add("hidden");
                    }
                    currentOpen = null;
                } else {
                    // opening
                    targetContent.classList.add("open");
                    targetContent.style.maxHeight = targetContent.scrollHeight + "px";
                    iconContainer.classList.add("open");
                    if (plusIcon && minusIcon) {
                        plusIcon.classList.add("hidden");
                        minusIcon.classList.remove("hidden");
                    }
                    currentOpen = targetContent;
                    // fade animation
                    const inner = targetContent.querySelector("div");
                    if (inner) {
                        inner.classList.add("fade-in-up");
                        setTimeout(()=>inner.classList.remove("fade-in-up"), 300);
                    }
                }
            });
        });
    });
})();
// ==================
(()=>{
    const section = document.getElementById("highValueSection");
    const image = section?.querySelector(".parallax-ql");
    if (!section || !image) return;
    const speed = 0.5; // adjust for more/less parallax
    window.addEventListener("scroll", ()=>{
        const rect = section.getBoundingClientRect();
        const offset = -rect.top * speed;
        image.style.transform = `translate3d(0, ${offset}px, 0)`;
    });
})();
// =======================
document.getElementById("toggleBtn")?.addEventListener("click", function() {
    var extraWrap = document.getElementById("extraWrap");
    var btnText = document.getElementById("btnText");
    var arrowIcon = document.getElementById("arrowIcon");
    var isHidden = extraWrap.classList.contains("hidden");
    if (isHidden) {
        extraWrap.classList.remove("hidden");
        btnText.textContent = "Read Less";
        arrowIcon.classList.add("rotate-180");
        this.setAttribute("aria-expanded", "true");
    } else {
        extraWrap.classList.add("hidden");
        btnText.textContent = "Read More";
        arrowIcon.classList.remove("rotate-180");
        this.setAttribute("aria-expanded", "false");
    }
});
// ==============
function $7554f63cde7b4371$var$updateClass() {
    const el = document.getElementById("curvebox");
    if (!el) return;
    const width = window.innerWidth;
    if (width >= 1150 && width <= 1300) {
        el.classList.add("bigShapeCurveBox1");
        el.classList.remove("bigShapeCurveBox2");
    } else if (width >= 1301) {
        el.classList.add("bigShapeCurveBox2");
        el.classList.remove("bigShapeCurveBox1");
    }
}
window.addEventListener("resize", $7554f63cde7b4371$var$updateClass);
window.addEventListener("load", $7554f63cde7b4371$var$updateClass);
document.addEventListener("DOMContentLoaded", ()=>{
    const countrySelect = document.getElementById("countryCode");
    if (!countrySelect) return;
    // Save original option labels once
    const originalLabels = [
        ...countrySelect.options
    ].map((option)=>option.textContent);
    // Restore all original labels
    const restoreLabels = ()=>{
        [
            ...countrySelect.options
        ].forEach((option, index)=>{
            option.textContent = originalLabels[index];
        });
    };
    // Show selected country code only
    const collapseToCode = ()=>{
        restoreLabels();
        const selectedOption = countrySelect.options[countrySelect.selectedIndex];
        if (selectedOption?.dataset.code) selectedOption.textContent = selectedOption.dataset.code;
    };
    // Events
    countrySelect.addEventListener("focus", restoreLabels);
    countrySelect.addEventListener("change", ()=>{
        requestAnimationFrame(collapseToCode);
    });
    // Initial state
    collapseToCode();
});


//# sourceMappingURL=about-us.cb697f87.js.map
